<template>
  <div v-if="state" class="messageBoxIndex" @click.stop="MessageBox">
    <div v-for="(dataList,key,index) in dataListArray" :key="key" class="messageBoxPosition" :style="{'top':messageBoxTop-0+(index*250+index*20)+'px','width':'496px','height':'250px'}">
      <div class="dataListTitle">
        <div style="line-height: 44px;">{{ key +`（${dataList.length}）` }}</div>
        <div style="flex:1" />
        <div><el-button type="text" style="font-size: 16px;" @click="allIgnore(dataList,key)">全都忽略</el-button></div>
      </div>
      <div class="wire" />
      <el-scrollbar style="height: 78%" :native="false" :noresize="false" tag="section" class="scrollbar">
        <el-form ref="ruleForm" label-width="88px" class="demo-ruleForm">
          <div v-for="(val ,i) in dataList" :key="i" class="frame el-fade-in-linear">
            <!-- <div v-html="val.content" /> -->
            <div v-if="val.contentJson" class="ruleFormTitle">{{ val.title }}</div>
            <el-form-item v-if="val.contentJson && val.contentJson.location && val.contentJson.username" label="所属房屋：" prop="pass">
              <div>{{ `${val.contentJson.location}` }}</div>
            </el-form-item>
            <el-form-item v-if="val.contentJson && val.contentJson.username" label="住户姓名：" prop="checkPass">
              <div>{{ `${val.contentJson.username}` }}</div>
            </el-form-item>
            <el-form-item v-if="val.contentJson && val.contentJson.typeName" label="设备名称：" prop="pass">
              <div>{{ `${val.contentJson.typeName}` }}</div>
            </el-form-item>
            <el-form-item v-if="(val.contentJson && val.contentJson.location && val.contentJson.typeName )|| val.title.includes('高空抛物')" label="安装位置：" prop="checkPass">
              <div>{{ `${val.contentJson.location}` }}</div>
            </el-form-item>
            <el-form-item v-if="val.contentJson && val.contentJson.plateNumber" label="车牌号：" prop="age">
              <div>{{ `${val.contentJson.plateNumber}` }}</div>
            </el-form-item>
            <el-form-item v-if="val.contentJson && val.contentJson.notificationTime" label="通知时间：" prop="age">
              <div>{{ `${val.contentJson.notificationTime}` }}</div>
            </el-form-item>
            <div v-if="val.contentJson" class="but">
              <el-button type="info" @click="neglect(dataList,i,key)">忽略</el-button>
              <el-button type="primary" @click="submitForm(val,list,i,key)">查看</el-button>
            </div>

          </div>
        </el-form>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import {
  getNotificationId
} from '@/api/message.js'
export default {
  name: 'MessageBoxIndex',
  components: {
  },
  props: {
    messageBoxLeft: {
      type: String,
      default: '25%'
    },
    messageBoxTop: {
      type: String,
      default: '55'
    },
    dataListArray: {
      type: Object,
      default: () => {}
    },
    customerType: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      state: false,
      dataLeft: '',
      totalWidth: document.documentElement.clientWidth
    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    document.body.appendChild(this.$el)
  },

  methods: {
    neglect(list, i, key) {
      list.splice(i, 1)
      if (list.length === 0) {
        delete this.dataListArray[key]
      }
      this.$forceUpdate()
    },
    allIgnore(list, key) {
      delete this.dataListArray[key]
      this.$forceUpdate()
    },
    updatePage() {
      this.$forceUpdate()
    },
    MessageBox(event) {

      // if (event.currentTarget === event.target) {
      //   this.state = false
      // }
    },

    submitForm(row, list, i, key) {
      // // 跳转审核
      // if (row.subType.includes('审核')) {
      //   this.jump('auditList', row)
      //   this.state = false
      // }
      // // 跳转住户详情
      // if (row.subType.includes('迁出') || row.subType.includes('人脸上传失败')) {
      //   this.jump('Household', row)
      //   this.state = false
      // }
      // // 跳转消息详情
      // if (row.subType.includes('消息')) {
      //   this.jump('messageNotification', row)
      //   this.state = false
      // }
      switch (row.subType) {
        // case '故障消息通知':
        case '非住户人脸上传失败':// 非住户管理	编辑
          this.jump('Household', row)
          this.state = false
          break
        case '住户迁出通知': // 住户管理	详情
        case '住户人脸上传失败':// 住户管理	编辑
          this.jump('Household', row)
          this.state = false
          break
        case '业主认证房屋审核通知': // 审核
        case '租客认证房屋审核-物业审核通知': // 审核
        case '人脸通行审核通知':// 审核
        case '车辆审核通知':// 审核
          this.jump('auditList', row)
          this.state = false
          break
        case '告警消息通知':// 消息通知	详情
          this.jump('messageNotification', row)
          this.state = false
          break
        default:
          break
      }
      this.neglect(list, i, key)
      getNotificationId(row.businessId)
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    isActive(route) {
      return route.path === this.$route.path
    },
    jump(name, row) {
      const view = this.$store.state.tagsView.visitedViews.filter((value) => {
        return value.name === name
      })[0]
      if (view && window.location.pathname === view.path) {
        if (this.isActive(view)) {
          this.$store.dispatch('tagsView/delCachedView', view).then(() => {
            const { fullPath } = view
            this.$nextTick(() => {
              if (name === 'Household') {
                console.log(row.contentJson)
                console.log({ identityId: row.businessId,
                  userId: row.contentJson.userId,
                  orgId: row.orgId,
                  assetId: row.contentJson.assetId,
                  interfaceStyle: row.contentJson.interfaceStyle })
                this.$router.replace({
                  path: '/redirect' + fullPath, query: {
                    id: row.businessId,
                    userId: row.contentJson.userId,
                    orgId: row.orgId,
                    assetId: row.contentJson.assetId,
                    interfaceStyle: row.contentJson.interfaceStyle }})
              } else {
                this.$router.replace({ path: '/redirect' + fullPath, query: { id: row.businessId }})
              }
            })
          })
        }
      } else {
        if (name === 'Household') {
          this.$router.replace({ name: name, params: {
            id: row.businessId,
            userId: row.contentJson.userId,
            orgId: row.orgId,
            assetId: row.contentJson.assetId,
            interfaceStyle: row.contentJson.interfaceStyle }})
        } else {
          this.$router.replace({ name: name, params: { id: row.businessId }})
        }
      }
    },
    personType(type) {
      for (let index = 0; index < this.customerType.length; index++) {
        const element = this.customerType[index]
        if (type === element.code) {
          return element.name
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.messageBoxIndex{
    // width: 100%;
    // height: 100%;
    // background-color: aqua;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 10000;
    .messageBoxPosition{
      position: absolute;
      background-color: #fff;
      right: 23px;
      border: 1px solid rgba(196, 196, 196, 0.5);
      box-shadow: 0px 2px 8px rgba(37, 44, 54, 0.25);
      .scrollbar{
        margin: 0 30px;
      }
      .frame{
          padding: 10px 0;
          border-top: 1px solid rgba(196, 196, 196, 0.5);
      }
      .frame:nth-last-child(1){
          // padding-bottom: 0;
          // border-bottom: none;
      }
      ::v-deep{
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }
        .is-horizontal {
            display: none;
        }
      }
    }
}
.ruleFormTitle{
  font-size: 16px;
  margin-bottom: 10px;
}
.el-form-item--small.el-form-item {
  margin-bottom: 0;
}
.detail{
  font-size: 16px;
  margin-left: 5px;
  margin-bottom: 12px;
}
.demo-ruleForm{
  ::v-deep{
    .el-form-item__label{
      font-size: 14px;
      color: #000;
    }
    .el-form-item__content{
      color: #606266;
    }
  }
}
.dataListTitle{
  font-size: 16px;
  display: flex;
  justify-content: center;
  padding-left: 38px;
  padding-right: 30px;
  padding-top: 8px;
  div+div{

  }
}
.but{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 17px;
}
</style>
